module.exports = __webpack_public_path__ + "static/img/truck-small.68610e2.svg";